const getWorkingLink = (link: string): string => {
    return link.startsWith('http://') || link.startsWith('https://') ? link : `https://${link}`;
};

export default getWorkingLink;
